import { Tour, Step } from "mapview-gui-utils/src/tour";
import { highlight, unhighlight } from "mapview-gui-utils/src/highlight";
import type { ComputedRef, Ref } from "vue";
import { computed, ref } from 'vue';

let pollQueryInterval : number | null = null;

function pollQuery(selector) {
  return new Promise((resolve, reject) => {
    if (pollQueryInterval) {
      clearInterval(pollQueryInterval)
    }
    const result = document.querySelector(selector);
    if (result && result.innerHTML) {
      resolve(result);
    }
    else {
      pollQueryInterval = window.setInterval(() => {
        const result = document.querySelector(selector);
        if (result && result.innerHTML) {
          clearInterval(pollQueryInterval!);
          resolve(result);
        }
      }, 100);
    }
    }
  )
}

class NasimTour extends Tour {
  constructor() {
    super();
    this.laengstesGewaesser = ref();
    this.triggerLaengstesGewaesser = ref(false);
  }
  laengstesGewaesser : Ref<string | undefined> = ref();
  triggerLaengstesGewaesser : Ref<boolean> = ref(false);

  setLaengstesGewaesser(laengstesGewaesser: string | undefined) {
    this.laengstesGewaesser.value = laengstesGewaesser;
  }

  getLaengstesGewaesser() {
    return this.laengstesGewaesser.value;
  }
}

const tour = new NasimTour();

tour.addStep(new Step({
  position: {
    anchor: "top",
    textBox: {
      position: "cc",
      anchor: "top"
    }
  },
  text: '<h4>Willkommen</h4>',
  buttons: [tour.getSkipButton("<span>Zum Modell</span>", "introButton"), tour.getNextButton("<span>Einführung starten</span>", "introButton")],
}));

tour.addStep(new Step({
  anchorElement: "#selectGewaesser",
  position: {
    anchor: "top",
    textBox: {
      position: "tl",
      anchor: "bottom"
    }
  },
  text: '<h4>Längsschnitt</h4>Wählen Sie hier ein Gewässer aus, um dessen Längsschnittprofil anzuzeigen. Übrigens: Die Auswahl funktioniert analog auch über einen Klick auf ein Gewässer in der Karte.',
  buttons: [tour.getNextButton("<span>Weiter</span>", "introButton")],
  onRenderStep: function () {
    tour.triggerLaengstesGewaesser.value = true;
  },
  onAfterStep: function () {
    tour.triggerLaengstesGewaesser.value = false;
  }
}));

tour.addStep(new Step({
  anchorElement: "#myChart",
  position: {
    anchor: "top",
    textBox: {
      position: "tl",
      anchor: "bottom"
    }
  },
  text: '<h4>Längsschnitt</h4>Sobald ein Gewässer ausgewählt wurde, können Sie mit dem Cursor über den Graph fahren und sich die Stelle, an der Ihr Cursor sich befindet, in der Karte anzeigen lassen. Durch einen Klick können Sie außerdem eine Markierung festsetzen und sich die genauen Abflusswerte im Info-Fenster anzeigen lassen.',
  buttons: [tour.getNextButton("<span>Weiter</span>", "introButton")]
}));

{
  const clickArea = document.createElement("div");
  clickArea.id = "clickArea";
  clickArea.className = "highlightmask";
  clickArea.style.cssText = "border-radius: 5px; position: absolute; top: 60%; left: 50%; transform: translate(-50%, -50%); width: 40%; height: 50%; pointer-events: none; display: flex; justify-content: center; align-items: center; text-align:center;";
  clickArea.innerHTML = "<h3 style='color: white; text-shadow: 0 0 3px black, 0 0 3px black, 0 0 3px black, 0 0 3px black;'>Klicken Sie auf Elemente in der Karte, um das Info-Fenster zu öffnen.</h3>";
  const func = () => {
    pollQuery(".popup-info").then(() => {
      tour.nextStep();
    });
    document.querySelector("#map")?.removeEventListener("click", func)
  };

  //@ts-ignore
  tour.addStep(new Step({
    anchorElement: "#clickArea",
    skipStepIf: function () {
      if (document.querySelector(".popup-info")) {
        document.body.querySelector("#map")?.appendChild(clickArea);
        document.querySelector("#map")?.addEventListener("click", func);
        return false;
      }
      return true;
    },
    onAfterStep: function () {
      document.querySelector("#map")?.removeEventListener("click", func);
      if (pollQueryInterval)
        clearInterval(pollQueryInterval);
      clickArea.remove();
    }
  }));
}

{
  const anchorSelector = ".popup-info";

  tour.addStep(new Step({
    anchorElement: anchorSelector,
    position: {
      anchor: "right",
      textBox: {
        position: "tc",
        anchor: "bottom"
      }
    },
    text: '<h4>Info-Fenster</h4>In diesem Fenster werden zusätzliche Informationen zu den ausgewählten Elementen angezeigt. Für Gerinne und Bauwerke können Sie außerdem den Schalter "Einzugsgebiet anzeigen" aktivieren, um das Einzugsgebiet des Elements hervorzuheben.',
    buttons: [tour.getNextButton("<span>Weiter</span>", "introButton")],
    onBeforeStep: function () {
      setTimeout(() => {
        tour.renderStep(tour.steps[tour.stepPosition]);
      }, 200);
    }
  }));
}

{
  const anchorSelector = "#menuOpener";
  const func = () => {
    const buttonSwitch = document.querySelector(anchorSelector);
    tour.nextStep();
    buttonSwitch?.removeEventListener("click", func);
  }
  tour.addStep(new Step({
    anchorElement: anchorSelector,
    position: {
      anchor: "left",
      textBox: {
        position: "tc",
        anchor: "bottom"
      }
    },
    text: '<h4>Seiten-Menü</h4> Im Seiten-Menü finden Sie zusätzliche Informationen zu der Karte und weitere Einstellmöglichkeiten.',
    buttons: [],
    onRenderStep: function () {
      highlight("#menuOpener");
    },
    onBeforeStep: function () {
      const buttonSwitch = document.querySelector(anchorSelector);
      buttonSwitch?.addEventListener("click", func)
    },
    onAfterStep: function () {
      const buttonSwitch = document.querySelector(anchorSelector);
      buttonSwitch?.removeEventListener("click", func);
      unhighlight("#menuOpener");
    }
  }));
}

//@ts-ignore
tour.addStep(new Step({
  onBeforeStep: function () {
    setTimeout(() => { tour.nextStep(); }, 300);
  }
}));

tour.addStep(new Step({
  anchorElement: ".wrap",
  position: {
    textBox: {
      position: "cc",
    }
  },
  text: '<h4>Informationen</h4> Hier können Sie: <ul><li>Kartenelemente sichtbar und unsichtbar schalten</li> <li>Beschriftungen in der Karte an- und abschalten</li> <li>die Hintergrundkarte ändern</li></ul>Des Weiteren finden Sie hier ggf. zusätzliche Informationen über das Modell.',
  buttons: [tour.getSkipButton("<span>Einführung beenden</span>", "introButton")]
}));

export default tour;